export const getYearRange = (year: number) => {
  const years: number[] = [];

  let newYear = year;

  while (newYear < new Date().getFullYear()) {
    newYear += 1;
    years.push(newYear);
  }

  return years;
};

export const activeCurrency = "₦";

export const requireValidation = {
  value: true,
  message: "required",
};

export const phoneNumberValidationPattern = {
  value: /^\d{10}$/,
  message: "invalidPhoneNumber",
};

export const emailValidationPattern = {
  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  message: "Invalid email address",
};

export const getTodayDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const formatDate = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const getMinMaxDates = () => {
  const today = new Date();
  const minDate = new Date(today.setFullYear(today.getFullYear() - 60)); // 60 years ago
  const maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 18)); // 18 years ago

  return {
    minDate: formatDate(minDate),
    maxDate: formatDate(maxDate),
  };
};

export function toOptions(data: any[], des: string | number) {
  return (
    data &&
    data.map((_: { [x: string]: any; id: any }) => {
      return {
        id: _.id,
        des: _[des],
      };
    })
  );
}

export const formatCurrency = (value, currency = "NGN") => {
  if (typeof value === "object") return value;
  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    minimumFractionDigits: 0,
    currency,
    currencyDisplay: "symbol",
    notation: "standard",
  }).format(value);
};

export const convertParamsToString = (url, urlVariables) => {
  let finalURL = url;
  for (const [key, value] of Object.entries(urlVariables)) {
    finalURL = finalURL.replace(`:${key}`, value);
  }
  return finalURL;
};

export const currencyCodeUtils = {
  NGN: { currencySymbol: "₦", phoneCode: "+234" },
  GHS: { currencySymbol: "GHS", phoneCode: "+233" },
  MGA: { currencySymbol: "MGA", phoneCode: "+261" }
};

export const getStatesForCountry = (countryCode: string = "NGN") => {
  const ghStates = [
    {
      code: "AH",
      name: "Ashanti",
      subdivision: null,
    },
    {
      code: "BA",
      name: "Brong-Ahafo",
      subdivision: null,
    },
    {
      code: "CP",
      name: "Central",
      subdivision: null,
    },
    {
      code: "EP",
      name: "Eastern",
      subdivision: null,
    },
    {
      code: "AA",
      name: "Greater Accra",
      subdivision: null,
    },
    {
      code: "NP",
      name: "Northern",
      subdivision: null,
    },
    {
      code: "UE",
      name: "Upper East",
      subdivision: null,
    },
    {
      code: "UW",
      name: "Upper West",
      subdivision: null,
    },
    {
      code: "TV",
      name: "Volta",
      subdivision: null,
    },
    {
      code: "WP",
      name: "Western",
      subdivision: null,
    },
  ].map((state, idx) => ({
    id: idx + 1,
    name: state.name,
    countryId: idx + 1,
    countryCode: "GH",
    iso2: "EN",
  }));

  const ngStates = [
    {
      id: 288,
      name: "Jigawa",
      countryId: 161,
      countryCode: "NG",
      iso2: "JI",
    },
    {
      id: 289,
      name: "Enugu",
      countryId: 161,
      countryCode: "NG",
      iso2: "EN",
    },
    {
      id: 290,
      name: "Kebbi",
      countryId: 161,
      countryCode: "NG",
      iso2: "KE",
    },
    {
      id: 291,
      name: "Benue",
      countryId: 161,
      countryCode: "NG",
      iso2: "BE",
    },
    {
      id: 292,
      name: "Sokoto",
      countryId: 161,
      countryCode: "NG",
      iso2: "SO",
    },
    {
      id: 293,
      name: "Abuja Federal Capital Territory",
      countryId: 161,
      countryCode: "NG",
      iso2: "FC",
    },
    {
      id: 294,
      name: "Kaduna",
      countryId: 161,
      countryCode: "NG",
      iso2: "KD",
    },
    {
      id: 295,
      name: "Kwara",
      countryId: 161,
      countryCode: "NG",
      iso2: "KW",
    },
    {
      id: 296,
      name: "Oyo",
      countryId: 161,
      countryCode: "NG",
      iso2: "OY",
    },
    {
      id: 297,
      name: "Yobe",
      countryId: 161,
      countryCode: "NG",
      iso2: "YO",
    },
    {
      id: 298,
      name: "Kogi",
      countryId: 161,
      countryCode: "NG",
      iso2: "KO",
    },
    {
      id: 299,
      name: "Zamfara",
      countryId: 161,
      countryCode: "NG",
      iso2: "ZA",
    },
    {
      id: 300,
      name: "Kano",
      countryId: 161,
      countryCode: "NG",
      iso2: "KN",
    },
    {
      id: 301,
      name: "Nasarawa",
      countryId: 161,
      countryCode: "NG",
      iso2: "NA",
    },
    {
      id: 302,
      name: "Plateau",
      countryId: 161,
      countryCode: "NG",
      iso2: "PL",
    },
    {
      id: 303,
      name: "Abia",
      countryId: 161,
      countryCode: "NG",
      iso2: "AB",
    },
    {
      id: 304,
      name: "Akwa Ibom",
      countryId: 161,
      countryCode: "NG",
      iso2: "AK",
    },
    {
      id: 305,
      name: "Bayelsa",
      countryId: 161,
      countryCode: "NG",
      iso2: "BY",
    },
    {
      id: 306,
      name: "Lagos",
      countryId: 161,
      countryCode: "NG",
      iso2: "LA",
    },
    {
      id: 307,
      name: "Borno",
      countryId: 161,
      countryCode: "NG",
      iso2: "BO",
    },
    {
      id: 308,
      name: "Imo",
      countryId: 161,
      countryCode: "NG",
      iso2: "IM",
    },
    {
      id: 309,
      name: "Ekiti",
      countryId: 161,
      countryCode: "NG",
      iso2: "EK",
    },
    {
      id: 310,
      name: "Gombe",
      countryId: 161,
      countryCode: "NG",
      iso2: "GO",
    },
    {
      id: 311,
      name: "Ebonyi",
      countryId: 161,
      countryCode: "NG",
      iso2: "EB",
    },
    {
      id: 312,
      name: "Bauchi",
      countryId: 161,
      countryCode: "NG",
      iso2: "BA",
    },
    {
      id: 313,
      name: "Katsina",
      countryId: 161,
      countryCode: "NG",
      iso2: "KT",
    },
    {
      id: 314,
      name: "Cross River",
      countryId: 161,
      countryCode: "NG",
      iso2: "CR",
    },
    {
      id: 315,
      name: "Anambra",
      countryId: 161,
      countryCode: "NG",
      iso2: "AN",
    },
    {
      id: 316,
      name: "Delta",
      countryId: 161,
      countryCode: "NG",
      iso2: "DE",
    },
    {
      id: 317,
      name: "Niger",
      countryId: 161,
      countryCode: "NG",
      iso2: "NI",
    },
    {
      id: 318,
      name: "Edo",
      countryId: 161,
      countryCode: "NG",
      iso2: "ED",
    },
    {
      id: 319,
      name: "Taraba",
      countryId: 161,
      countryCode: "NG",
      iso2: "TA",
    },
    {
      id: 320,
      name: "Adamawa",
      countryId: 161,
      countryCode: "NG",
      iso2: "AD",
    },
    {
      id: 321,
      name: "Ondo",
      countryId: 161,
      countryCode: "NG",
      iso2: "ON",
    },
    {
      id: 322,
      name: "Osun",
      countryId: 161,
      countryCode: "NG",
      iso2: "OS",
    },
    {
      id: 323,
      name: "Ogun",
      countryId: 161,
      countryCode: "NG",
      iso2: "OG",
    },
    {
      id: 4926,
      name: "Rivers",
      countryId: 161,
      countryCode: "NG",
      iso2: "RI",
    },
  ];

  const mgRegions = [
    { id: 1, name: "Analamanga", countryId: 474, countryCode: "MG", iso2: "AM" },
    { id: 2, name: "Vakinankaratra", countryId: 474, countryCode: "MG", iso2: "VK" },
    { id: 3, name: "Itasy", countryId: 474, countryCode: "MG", iso2: "IT" },
    { id: 4, name: "Bongolava", countryId: 474, countryCode: "MG", iso2: "BL" },
    { id: 5, name: "Diana", countryId: 474, countryCode: "MG", iso2: "DY" },
    { id: 6, name: "Sava", countryId: 474, countryCode: "MG", iso2: "SV" },
    { id: 7, name: "Amoron’i Mania", countryId: 474, countryCode: "MG", iso2: "AMN" },
    { id: 8, name: "Haute Matsiatra", countryId: 474, countryCode: "MG", iso2: "HM" },
    { id: 9, name: "Ihorombe", countryId: 474, countryCode: "MG", iso2: "IH" },
    { id: 10, name: "Vatovavy", countryId: 474, countryCode: "MG", iso2: "VT" },
    { id: 11, name: "Fitovinany", countryId: 474, countryCode: "MG", iso2: "FV" },
    { id: 12, name: "Atsimo Atsinanana", countryId: 474, countryCode: "MG", iso2: "AA" },
    { id: 13, name: "Alaotra-Mangoro", countryId: 474, countryCode: "MG", iso2: "AMG" },
    { id: 14, name: "Analanjirofo", countryId: 474, countryCode: "MG", iso2: "ANJ" },
    { id: 15, name: "Betsiboka", countryId: 474, countryCode: "MG", iso2: "BS" },
    { id: 16, name: "Boeny", countryId: 474, countryCode: "MG", iso2: "BE" },
    { id: 17, name: "Melaky", countryId: 474, countryCode: "MG", iso2: "MK" },
    { id: 18, name: "Sofia", countryId: 474, countryCode: "MG", iso2: "SF" },
    { id: 19, name: "Menabe", countryId: 474, countryCode: "MG", iso2: "MB" },
    { id: 20, name: "Atsimo-Andrefana", countryId: 474, countryCode: "MG", iso2: "AAW" },
    { id: 21, name: "Anosy", countryId: 474, countryCode: "MG", iso2: "AN" },
    { id: 22, name: "Androy", countryId: 474, countryCode: "MG", iso2: "AY" },
    { id: 23, name: "Analamanga", countryId: 474, countryCode: "MG", iso2: "AL" }
  ];


  const states = {
    GHS: ghStates,
    NGN: ngStates,
    MGA: mgRegions,
  };
  if (states) {
    const sortedStates = [...states[countryCode]].sort((a, b) => {
      if (a.name > b.name) return 1;
      else if (a.name < b.name) return -1;
      return 0;
    });
    return sortedStates?.map((state) => state?.name);
  }
  return [];
};

export const extractFieldNames = (fieldsArray) => fieldsArray.map((field) => field.name);

export const ozeLoans = "oze-loans";